<div class="mainContainer card overflow-auto margin mt-4">
    <div class="loader" *ngIf="loading">
        <mat-spinner diameter="30"></mat-spinner>
    </div>
    <div class="reminder mb-0 d-flex bg-light justify-content-between flex-column flex-sm-row">
        <h5 class="card-title ps-4 mb-0 tableTitle"> {{totalCount}} Assignments(s)</h5>
        <div class="form-inline ms-auto me-4 d-none d-md-flex hstack card-title ps-4 mb-0">
        </div>
    </div>
    <table matSort (matSortChange)="sortData($event)" class=" table table-borderless datatable">
        <thead class="table-light">
          <tr>
            <th mat-sort-header="job" scope="col" class="ps-5">Job</th>
            <th mat-sort-header="candidate" scope="col">Candidate</th>
            <th mat-sort-header="client" scope="col">Client</th>
            <th mat-sort-header="start_date" scope="col">Start Date</th>
            <th mat-sort-header="end_date" scope="col">End Date</th>
            <th mat-sort-header="created_at" scope="col">Created At</th>
            <th *ngIf="user?.role_uuid !== ROLES?.CANDIDATE" mat-sort-header="action" scope="col">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr class="assignmentsRow dataColumn" *ngFor="let jobAssignment of jobAssignments">
            <td *ngIf="user?.role_uuid === ROLES?.CANDIDATE" class="text-heading font-bold ps-5">
              <div class="textWithIcon">
                <i class="bi bi-briefcase"></i>
                <span>{{jobAssignment.job}}</span>
              </div>
            </td>
            <td *ngIf="user?.role_uuid !== ROLES?.CANDIDATE" class="text-heading font-bold ps-5">
              <div class="textWithIcon">
                <i class="bi bi-briefcase"></i>
                <span>{{jobAssignment.job}}</span>
              </div>
            </td>
            <td>{{jobAssignment.candidate}}</td>
            <td>{{jobAssignment.client}}</td>
            <td>{{dataSharedService.tranformDate(jobAssignment.start_date)}}</td>
            <td>{{dataSharedService.tranformDate(jobAssignment.end_date)}}</td>
            <td>{{dataSharedService.tranformDate(jobAssignment.created_at)}}</td>
            <td *ngIf="user?.role_uuid !== ROLES?.CANDIDATE">
              <div class="row-actions">
                <button type="button" *ngIf="user?.role_uuid === ROLES?.AGENCY || user?.role_uuid === ROLES?.CLIENT" class="icon-btn-sm approve" matTooltip="Activate assignment" [matTooltipPosition]="'left'" (click)="activateAssignment(jobAssignment.uuid)">
                  <i class="bi bi-lock"></i>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="card-pagination" *ngIf="totalCount">
        <span class="pagination-summary">
          Showing {{ pageStart }}–{{ pageEnd }} of {{ totalCount }} assignments
        </span>
        <app-api-paginator [totalCount]="totalCount" (onStepChange)="onStepChange($event)"></app-api-paginator>
      </div>
</div>